import { SystemUser } from "./system-user";

export class ContactRequestComment {

    constructor(
        public body: string,
        public contactRequestId: number,
        public id?: number,
        public createdBy?: SystemUser,
        public created?: Date,
        public lastModifiedBy?: SystemUser,
        public lastModified?: Date,
        public isDeleted?: boolean
    ){}
}
